import { AgeRangeValue } from 'components/date/AgeRange'
import { FaixaEtariaEnum, IdentidadeGeneroEnum, SexoEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

export interface AcompanhamentoFilterModel {
  sexo?: SexoEnum[]
  identidadeGenero?: IdentidadeGeneroEnum[]
  faixaEtariaRange?: AgeRangeValue
  tipoFaixaEtaria?: FaixaEtariaEnum
}

export const hasFaixaEtariaRange = (faixaEtariaRange?: AgeRangeValue): boolean =>
  !isUndefinedOrNull(faixaEtariaRange?.firstValue) || !isUndefinedOrNull(faixaEtariaRange?.secondValue)

export const faixaEtariaRecord: Record<FaixaEtariaEnum, string> = {
  [FaixaEtariaEnum.TODAS_FAIXAS]: 'Todas as faixas',
  [FaixaEtariaEnum.CRIANCA]: 'Criança (0 a 10 anos)',
  [FaixaEtariaEnum.ADOLESCENTE]: 'Adolescente (11 a 19 anos)',
  [FaixaEtariaEnum.ADULTO]: 'Adulto (20 a 59 anos)',
  [FaixaEtariaEnum.IDOSO]: 'Pessoa idosa (60 anos ou mais)',
  [FaixaEtariaEnum.OUTRA]: 'Outra',
}

export interface AcompanhamentoFilterConfig<T> {
  label: string
  getValue?: (filter: T) => string
  shouldRender?: (filter: T) => boolean
}
